import { Injectable } from '@jkhy/frontend-utils/di';
import { RolesClient } from '@treasury/api/bo';
import { Role } from '../../../users/fi-user.entity';

@Injectable()
export class RolesService {
    constructor(private readonly rolesClient: RolesClient) {}

    /**
     *
     * @returns A promise that resolves to the list of roles.
     * @throws An error if the API call fails.
     */
    public async getRoles() {
        return (await this.rolesClient.rolesGetAll()).data.map(role => new Role(role));
    }

    public async getRoleById(roleId: number) {
        const roleDto = await this.rolesClient.rolesGetById(roleId);
        return new Role(roleDto.data);
    }

    public async addRole(role: Role) {
        return await (await this.rolesClient.rolesAddRole(role.toDto())).json();
    }

    public async updateRole(role: Role) {
        return await (await this.rolesClient.rolesUpdateRole(role.toDto())).json();
    }

    public async deleteRole(roleId: number) {
        return this.rolesClient.rolesDeleteRole(roleId);
    }
}
